import { usersActions } from '../reducers/usersReducer';
import api from "../../api/api";
import { success, error } from "../../components/notify/notify";
import { getDataFromLocalStorage, localStorageData, setDataToLocalStorage } from '../../services/localStorage';
import { CUSTOM_HEADERS } from '../../constants/custom-headers';
import { MSG } from '../../constants/messages';
import { handleApiError } from '../../services/errorHandler';
import { authActions } from '../reducers/authReducer';

export const onSignIn = (username, password) => {
  return (dispatch) => {
    // dispatch(authActions.onSetLoaded(false));

    return api.authUser({ username, password }).then((response) => {
      const accessToken = response.headers[CUSTOM_HEADERS.AccessToken];
      const deviceId = response.headers[CUSTOM_HEADERS.DeviceId.toLocaleLowerCase()];

      dispatch(authActions.onInitialAuth(response.data));
      if (accessToken) {
        setDataToLocalStorage(localStorageData.user, { ...response.data, accessToken: accessToken, deviceId });
      }
    })
      .catch(function (e) {
        const content = (e.response && e.response.data) || e.message || e.toString();
        error(`Ошибка при авторизации ${username}. ${content.message}`, false);
        dispatch(authActions.onSetError('Ошибка при авторизации'));
      });
  }
};

export const onSignUp = (username, password, roles) => {
  return (dispatch) => {
    return api.createUser({ username, password, roles }).then((response) => {
      dispatch(usersActions.createDataSuccess({ data: response.data.data }));
      success(MSG.user.success.create(username), false);
      return true;
    })
      .catch(function (e) {
        const errorMessage = handleApiError(e, MSG.user.error.create);
        if (errorMessage) {
          error(errorMessage, false);
        }
        return false;
      });
  }
};

export const onLogout = () => {
  const { id: userId } = getDataFromLocalStorage(localStorageData.user);
  if (!userId) return new Error("Logout error");
  return (dispatch) => {
    dispatch(authActions.onLocalLogout());
    return api.logout(userId).then((response) => {
      return true;
    })
      .catch(function (e) {
        return false;
      });
  }
};